import Color from 'color';
import {
  bgColor,
  borderColor,
  LEFT_SIDE_PANEL_MOTION_MS,
  leftSidePanelMotionEase,
  logRes1,
  mobileRes2,
  topBarColor,
  topBarColor2,
} from 'pages/styles';
import styled, { keyframes } from 'styled-components';

const lFColor = '#490c7b';
const lFColor0 = '#7914cc';
const orange = Color('#d6a615').darken(0).toString();
const ink = '#212529';
const inkMuted = '#6c757d';

const totalFooterSize = '63px';
const pagesFooterSize = '54px';
const cashFooterRes = '1165px';
const cashFooterSize = '58px';
const mainFooterSize = `${Number(pagesFooterSize.replace('px', '')) +
  Number(totalFooterSize.replace('px', ''))}px`;
export const Container = styled.div<{ isCashGroup: boolean }>`
  position: relative;
  overflow: hidden;
  margin: 0;
  padding: 1px;
  flex: 1;
  padding-bottom: ${({ isCashGroup }) => isCashGroup ? mainFooterSize : pagesFooterSize};
  z-index: 1;
  display: flex;
  flex-direction: column;
  @media(max-width: ${cashFooterRes}) {
    padding-bottom: ${({ isCashGroup }) => isCashGroup && `calc(${mainFooterSize} + ${cashFooterSize})`};
  }
`;

export const AllCont = styled.div`
  border-radius: 3px;
  flex: 0 1;
  max-height: 100%;
  box-shadow: 0px 0px 1px 0.5px ${Color('lightgrey').darken(0.1).toString()};
  -webkit-box-shadow: 0px 0px 1px 0.5px ${Color('lightgrey').darken(0.1).toString()};
  -moz-box-shadow: 0px 0px 1px 0.5px ${Color('lightgrey').darken(0.1).toString()};
`;

export const Cont1 = styled.div`
  width: 100%;
  height: max-content;
  max-height: 100%;
  overflow: auto;
  z-index: 1;
  background: white;
  border-radius: 3px;
  border-bottom-right-radius: 0px;
  border-bottom-left-radius: 0px;
  @media(max-width: ${logRes1}) {
    border: none;
  }
`;

/** Sticky value column — total footer amount block uses the same widths. */
const auditValueColumnWidth = '145px';
const valueTHWidth = '112px';
const detailTHWidth = 'calc(100vw - 15px)';
export const Table = styled.table<{ isCashGroup: boolean, itemCount: number }>`
  width: 100%;
  min-width: ${({ isCashGroup, itemCount }) => isCashGroup ? `calc(1000px + 60px + ${itemCount * 4}px)`
    : `calc(840px + 60px + ${itemCount * 4}px)`};
  height: max-content;
  font-weight: 100;
  color: #525252;
  table-layout: fixed;
  border-collapse: separate;
  border: none;
  border-spacing: 0;
  @media(max-width: ${mobileRes2}) {
    min-width: ${({ isCashGroup, itemCount }) => isCashGroup
    ? `calc((${detailTHWidth} - ${valueTHWidth}) + 470px + ${itemCount * 4}px)`
    : `calc(${detailTHWidth} + 390px + ${itemCount * 4}px)`};
  }
`;

export const THead = styled.thead`
  width: 100%;
  position: sticky;
  top: 0;
  z-index: 2;
`;

export const TR = styled.tr`
  z-index: 1;
`;

const tableBorderColor = borderColor;
export const TH = styled.th<{ isEmpty: boolean, isCashGroup: boolean }>`
  padding: 15px 30px;
  padding-bottom: 16px;
  text-align: right;
  background: white;
  width: ${({ isCashGroup }) => !isCashGroup ? 'calc(100% / 3.35)' : 'calc(100% / 4.55)'};
  font-weight: 500;
  z-index: 3;
  font-size: 12px;
  border-bottom: ${({ isEmpty }) => !isEmpty && `1px solid ${Color(tableBorderColor).lighten(0.6).toString()}`};
  @media(max-width: ${mobileRes2}) {
    width: ${({ isCashGroup }) => !isCashGroup ? 'calc(100% / 2.1)' : 'calc(100% / 1.65)'};
    padding: 12px 15px;
  }
`;

export const lightPurple = Color('#eadaf0').lighten(0.045).toString();

export const TH2 = styled(TH)`
  width: calc(100% / 1.95);
  background: ${lightPurple};
  border-bottom: ${({ isEmpty }) => !isEmpty && `1px solid ${Color('#eadaf0').darken(0.05).toString()}`};
  @media(max-width: ${mobileRes2}) {
    width: ${({ isCashGroup }) => !isCashGroup ? `calc(${detailTHWidth})`
    : `calc(${detailTHWidth} - ${valueTHWidth})`};
  }
`;

export const TH3 = styled(TH)`
  width: 200px;
  @media(max-width: ${mobileRes2}) {
    width: 163px;
  }
`;

export const AuditHeaderRow = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 2px;
  max-width: 100%;
`;

export const TH4 = styled(TH)`
  width: ${auditValueColumnWidth};
  border-left: 1px solid ${Color('lightgrey').lighten(0.065).toString()};
  position: sticky;
  right: 0;
  @media(max-width: ${mobileRes2}) {
    width: ${valueTHWidth};
  }
`;

export const ValueModeSelect = styled.select`
  appearance: none;
  -webkit-appearance: none;
  background: white
    url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath fill='%23666' d='M0 0l5 6 5-6z'/%3E%3C/svg%3E")
    no-repeat right 2px center;
  border: 1px solid ${Color('lightgrey').darken(0.05).toString()};
  border-radius: 4px;
  color: ${topBarColor2};
  font-size: 11.5px;
  font-weight: 700;
  letter-spacing: 0.02em;
  text-transform: capitalize;
  padding: 3px 16px 3px 7px;
  cursor: pointer;
  max-width: 100%;
  &:focus {
    outline: none;
    border-color: ${lFColor0};
  }
`;

export const TH7 = styled(TH)<{ itemCount: number }>`
  width: ${({ itemCount }) => `calc(60px + ${itemCount * 4}px)`};
  @media(max-width: ${mobileRes2}) {
    width: ${({ itemCount }) => `calc(35px + ${itemCount * 4}px)`};
  }
`;

export const TR2 = styled.tr``;

/** /audits jump-to-row blue. */
const hColor = Color(topBarColor).lighten(0.875).toString();
const hColorMessage = Color(hColor).darken(0.025).toString();
const newColor = Color(orange).lighten(1.05).toString();

export const TD = styled.td<{
  fontWeight?: number, isLast?: boolean, highlighted: number, ind: number, isNew: boolean
}>`
  padding: 28px 30px;
  text-align: right;
  font-weight: ${({ fontWeight }) => fontWeight ?? 400};
  font-size: 12.5px;
  line-height: 1.7;
  overflow: visible;
  border-bottom: 1px solid ${Color(tableBorderColor).lighten(0.6).toString()};
  border: ${({ isLast }) => isLast && 'none'};
  z-index: 1;
  background: ${({ isNew }) => isNew && newColor};
  background: ${({ highlighted, ind }) => highlighted === ind && hColor};
  border-bottom: ${({ highlighted, ind }) => (ind === highlighted - 1 || ind === highlighted) && 'none'};
  border-color: ${({ isNew }) => isNew && Color(newColor).darken(0.075).toString()};
  @media(max-width: ${mobileRes2}) {
    padding: 20px 15px;
    font-size: 11.5px;
    line-height: 1.55;
  }
`;

export const TD1 = styled(TD)`
  line-height: 1.8;
  background: ${Color('#eadaf0').lighten(0.075).toString()};
  background: ${({ isNew }) => isNew && Color(newColor).darken(0.03).toString()};
  background: ${({ highlighted, ind }) => highlighted === ind && hColorMessage};
  border-bottom: 1px solid ${Color('#eadaf0').darken(0.015).toString()};
  border-color: ${({ isNew }) => isNew && Color(newColor).darken(0.125).toString()};
  border-bottom: ${({ highlighted, ind }) => (ind === highlighted - 1 || ind === highlighted) && 'none'};
  @media(max-width: ${mobileRes2}) {
    font-size: 12px;
    line-height: 1.65;
  }
`;

export const TD2 = styled(TD)`
  border-left: 1px solid ${Color('lightgrey').lighten(0.065).toString()};
  border-left-color: ${({ isNew }) => isNew && Color(newColor).darken(0.075).toString()};
  border-left-color: ${({ highlighted, ind }) => (ind === highlighted) &&
    Color(hColor).darken(0.075).toString()};
  position: sticky;
  right: 0; 
  background: white;
  background: ${({ isNew }) => isNew && newColor};
  background: ${({ highlighted, ind }) => highlighted === ind && hColor};
`;

export const RelCont = styled.div`
  position: relative;
  width: 100%;
`;

export const TD3 = styled(TD)`
  font-size: 11.5px;
  font-weight: 300;
`;

export const TD3Entry = styled.div`
  width: max-content;
  padding: 23px 30px;
  padding-left: 0px;
  width: 100%;
  margin: 0;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
`;

export const cashColor = Color('#40b017').darken(0.25).toString();
export const redColor = '#eb364b';

export const RestoreBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  margin: 0;
  padding: 5px 10px;
  border: none;
  border-radius: 7px;
  background: ${Color(cashColor).alpha(0.12).toString()};
  color: ${cashColor};
  font-size: 11px;
  font-weight: 600;
  font-family: inherit;
  line-height: 1;
  cursor: pointer;
  vertical-align: middle;
  transition: background 120ms ease;
  &:hover {
    background: ${Color(cashColor).alpha(0.2).toString()};
  }
  svg {
    font-size: 14px !important;
  }
`;

export const CloseReportBtn = styled(RestoreBtn)`
  background: ${Color(redColor).alpha(0.1).toString()};
  color: ${redColor};
  &:hover {
    background: ${Color(redColor).alpha(0.18).toString()};
  }
`;

/** Inline with message text — sits at end of the details line. */
export const RestoreActions = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 6px;
  margin-left: 4px;
  vertical-align: middle;
`;

/** Date text + line-style time-range icon on /audits rows. */
export const DateCell = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: flex-end;
  flex-wrap: wrap;
  gap: 4px;
  max-width: 100%;
  text-align: right;
`;

/** Combined SKU details only — 3 lines, then ellipsis. Matches other /audits cells. */
export const CombinedSkuDetails = styled.span`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 3;
  overflow: hidden;
  width: 100%;
  text-align: right;
  overflow-wrap: anywhere;
`;

/** Soft purple chip matching Username / details-cell theme (not a white card). */
export const RestoreToggle = styled.button<{ $open?: boolean }>`
  appearance: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  padding: 0;
  border: none;
  border-radius: 6px;
  background: ${({ $open }) => ($open
    ? Color(lFColor0).alpha(0.2).toString()
    : Color(lFColor0).alpha(0.1).toString())};
  color: ${({ $open }) => ($open ? lFColor : Color(lFColor).alpha(0.72).toString())};
  cursor: pointer;
  vertical-align: middle;
  transition: background 120ms ease, color 120ms ease;

  &:hover {
    background: ${Color(lFColor0).alpha(0.22).toString()};
    color: ${lFColor};
  }
`;

/** Clickable "audit" token inside deleted / restored / change messages (&L&uuid&L&). */
export const AuditIdLink = styled.button`
  appearance: none;
  border: none;
  background: transparent;
  padding: 0;
  margin: 0;
  font: inherit;
  font-weight: 600;
  color: ${Color(topBarColor).darken(0.08).toString()};
  cursor: pointer;
  vertical-align: baseline;

  &:hover {
    color: ${Color(topBarColor).darken(0.22).toString()};
  }
`;

/** Clickable "restored" on post-restore Audit deleted rows (&R&uuid&R&) — no underline. */
export const RestoredIdLink = styled.button`
  appearance: none;
  border: none;
  background: transparent;
  padding: 0;
  margin: 0;
  font: inherit;
  font-weight: 600;
  color: ${cashColor};
  cursor: pointer;
  vertical-align: baseline;

  &:hover {
    color: ${Color(cashColor).darken(0.12).toString()};
  }
`;

export const CashIn = styled.div`
  color: ${cashColor};
  font-weight: 700;
  font-size: 13.5px;
  letter-spacing: 0.75px;
  display: inline-block;
  position: absolute;
  bottom: 50%;
  right: 30px;
  transform: translateY(50%);
  padding: 5px 10px;
  padding-right: 0px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: calc(100% - 50px);
  border-radius: 3px;
  width: max-content;
  margin-left: auto;
  @media(max-width: ${mobileRes2}) {
    font-size: 13px;
    max-width: calc(100% - 20px);
    right: 15px;
  }
  &:hover {
    text-overflow: clip;
    white-space: normal;
    overflow: visible;
    background: inherit;
    word-break: break-all;
    max-width: none;
    width: max-content;
  }
`;

export const CashOut = styled(CashIn)`
  color: ${redColor};
`;

/** Units column entries + page sums — matches Total ($neutral) color. */
export const UnitsEntry = styled(CashIn)`
  color: ${topBarColor2};
  font-weight: 800;
  font-size: 14.5px;
  letter-spacing: 0.4px;
  @media(max-width: ${mobileRes2}) {
    font-size: 14px;
  }
`;

export const MoreCont = styled.div`
  color: ${Color('grey').lighten(0.5).toString()};
  position: absolute;
  right: 5px;
  bottom: 50%;
  width: max-content;
  height: max-content;
  overflow: visible;
  transform: translateY(50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  @media(max-width: ${mobileRes2}) {
    right: 1px;
  }
`;

export const RelMoreCont = styled.div`
  position: relative;
  width: max-content;
  height: max-content;
`;

export const MoreIcon0 = styled.div`
  width: 10px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    color: ${lFColor};
    cursor: pointer;
  }
`;

export const MoreIconsCont = styled.div`
  width: max-content;
  height: 0px;
  pointer-events: none;
  overflow: hidden;
  position: absolute;
  top: -97px;
  right: 0;
  opacity: 0;
  padding: 20px;
  padding-right: 1px;
  padding-bottom: 1px;
  transition: all ease-out 100ms;
`;

export const MoreIconsCont1 = styled.div`
  width: 35px;
  background: white;
  border-radius: 2px;
  border: 1px solid grey;
`;

export const MoreIcon = styled.div`
  color: ${Color('grey').lighten(0.3).toString()};
  width: 100%;
  height: 35px;
  padding-top: 5px;
  padding-bottom: 3px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:hover {
    color: ${redColor};
    background: ${Color(redColor).lighten(0.7).toString()};
  }
`;

export const MoreIcon1 = styled(MoreIcon)`
  padding-top: 3px;
  padding-bottom: 5px;
  &:hover {
    color: #525252;
    background: ${Color('lightgrey').lighten(0.1).toString()};
  }
`;

export const EditAmountCont = styled(MoreIconsCont)`
  top: -172px;
  width: calc(100vw - 35px);
  min-width: 0;
  max-width: 320px;
  padding-top: 28px;
  padding-bottom: 12px;
  @media(max-width: 400px) {
    padding-left: 0px;
  }
`;

export const EditAmountCont1 = styled.div`
  background: #fff;
  padding: 12px 14px 14px;
  width: 100%;
  margin-left: auto;
  max-width: 280px;
  box-sizing: border-box;
  border-radius: 10px;
  border: 1.5px solid ${Color(lFColor0).alpha(0.16).toString()};
  box-shadow:
    0 10px 28px rgba(33, 37, 41, 0.14),
    0 0 0 1px rgba(33, 37, 41, 0.04);
`;

export const EditThisCont = styled.div`
  color: ${ink};
  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 10px;
  z-index: 2;
`;

export const HeaderPart = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const Header3 = styled.div`
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.01em;
  color: ${lFColor};
  width: max-content;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
  max-width: calc(100% - 36px);
`;

export const IconCont2 = styled.div`
  height: 26px;
  width: 26px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  margin-left: auto;
  border-radius: 6px;
  color: ${inkMuted};
  flex-shrink: 0;
  transition: color 120ms ease, background 120ms ease;
  &:hover {
    color: ${redColor};
    background: ${Color(redColor).alpha(0.1).toString()};
  }
`;

export const AmountPart = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
`;

export const Info1 = styled.div<{ isError?: boolean }>`
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: ${({ isError }) => (isError ? redColor : inkMuted)};
  padding-left: 2px;
  line-height: 1.3;
`;

export const InputRow = styled.div<{ isError?: boolean }>`
  display: flex;
  align-items: stretch;
  width: 100%;
  min-width: 0;
  border-radius: 8px;
  overflow: hidden;
  border: 1.5px solid
    ${({ isError }) => (isError ? redColor : '#ced4da')};
  background: #fff;
  transition: border-color 120ms ease, box-shadow 120ms ease;
  &:focus-within {
    border-color: ${({ isError }) => (isError ? redColor : lFColor0)};
    box-shadow: 0 0 0 0.2rem
      ${({ isError }) => (
    isError
      ? Color(redColor).alpha(0.16).toString()
      : Color(lFColor0).alpha(0.18).toString()
  )};
  }
`;

export const Input1 = styled.input<{ isError: boolean, amount: number }>`
  height: 44px;
  padding: 0 12px;
  border: 0;
  flex: 1;
  min-width: 0;
  background: transparent;
  font-weight: 700;
  font-size: 17px;
  letter-spacing: 0.4px;
  font-family: inherit;
  color: ${({ amount }) => (amount < 0 ? redColor : cashColor)};
  &:focus {
    outline: none;
  }
  &::placeholder {
    color: ${Color(inkMuted).alpha(0.55).toString()};
    font-weight: 600;
  }
`;

export const Button = styled.div`
  font-size: 13px;
  height: 44px;
  display: flex;
  padding: 0 16px;
  justify-content: center;
  align-items: center;
  width: max-content;
  flex-shrink: 0;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #fff;
  background: ${lFColor};
  transition: background 120ms ease;
  user-select: none;
  &:hover {
    background: ${lFColor0};
    cursor: pointer;
  }
`;

/** Same purple as the room name chip. */
const roomAccent = Color(lFColor).lighten(0.6).toString();
/** Guest photo ring: muted green, distinct from staff (no ring) and room purple. */
const customerPhotoRing = Color('#40b017').lighten(0.18).alpha(0.8).toString();

export const Username = styled.span<{ isRemoved?: boolean }>`
  padding: 0;
  margin: 0;
  border: none;
  transform: translateY(-1px);
  border-radius: 5px;
  display: inline-flex;
  align-items: center;
  gap: 5px;
  width: max-content;
  font-weight: 600;
  margin: 0px 2px;
  font-size: 11px;
  color: ${({ isRemoved }) => (
    isRemoved ? Color(topBarColor2).alpha(0.45).toString() : topBarColor2
  )};
  line-height: 1.2;
  vertical-align: middle;
  @media(max-width: ${mobileRes2}) {
    font-size: 10.5px;
  }
`;

/** Guest chip: black-based name, distinct from staff blue. */
export const Customer = styled(Username)`
  color: ${({ isRemoved }) => (
    isRemoved ? Color(ink).alpha(0.45).toString() : ink
  )};
`;

export const UsernamePhoto = styled.img<{ $ring?: boolean }>`
  width: 23px;
  height: 23px;
  border-radius: 50%;
  object-fit: cover;
  flex-shrink: 0;
  background: #eef1f4;
  cursor: zoom-in;
  box-sizing: border-box;
  ${({ $ring }) => $ring && `
    border: 1.5px solid ${customerPhotoRing};
  `}
`;

export const PhotoPreviewPopup = styled.div`
  position: fixed;
  z-index: 1400;
  width: 112px;
  height: 112px;
  padding: 3px;
  border-radius: 50%;
  background: #fff;
  box-shadow: 0 10px 28px rgba(0, 0, 0, 0.18), 0 0 0 1px rgba(0, 0, 0, 0.06);
  pointer-events: none;
`;

export const PhotoPreviewImg = styled.img`
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
  display: block;
  background: #eef1f4;
`;

export const UsernamePhotoFallback = styled.span<{ isRemoved?: boolean; $ring?: boolean }>`
  width: 23px;
  height: 23px;
  border-radius: 50%;
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  background: ${({ isRemoved }) => (
    isRemoved
      ? Color(lFColor0).alpha(0.08).toString()
      : Color(lFColor0).alpha(0.14).toString()
  )};
  color: ${({ isRemoved }) => (
    isRemoved ? Color(lFColor).alpha(0.45).toString() : lFColor
  )};
  ${({ $ring }) => $ring && `
    border: 2px solid ${customerPhotoRing};
  `}

  & > svg {
    width: 17.5px;
    height: 17.5px;
  }
`;

export const UsernameText = styled.span<{ isRemoved?: boolean }>`
  display: inline-block;
  transform: translateY(1.5px);
  text-decoration: ${({ isRemoved }) => (isRemoved ? 'line-through' : 'none')};
  text-decoration-thickness: 1px;
`;

export const Bold = styled.span`
  font-weight: 600;
  color: ${Color('#525252').darken(0.15).toString()};
`;

export const StockChange = styled.div`
  display: block;
  margin-top: 4px;
  color: ${Color('#525252').darken(0.12).toString()};
  line-height: 1.5;
`;

export const StockChangeLine = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  flex-wrap: wrap;
`;

export const StockChangeIcon = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #8f4d3d;
  line-height: 0;
  transform: translateY(-1px);

  .MuiSvgIcon-root {
    font-size: 13px;
  }
`;

export const StockChangeLabel = styled.span`
  font-weight: 700;
  color: ${Color('#525252').darken(0.12).toString()};
`;

export const StockChangeValue = styled.span`
  font-weight: 700;
  color: ${Color('#525252').darken(0.12).toString()};
`;

export const StockArrow = styled.span`
  display: inline-flex;
  align-items: center;
  vertical-align: -2px;
  margin: 0 1px;
  color: ${Color('#525252').darken(0.05).toString()};
  line-height: 0;

  .MuiSvgIcon-root {
    font-size: 14px;
  }
`;

export const OTA = styled.span<{ $accent?: string; $darkText?: boolean }>`
  display: inline-flex;
  align-items: center;
  font-weight: 500;
  color: ${({ $darkText }) => ($darkText ? '#1a1a1a' : 'white')};
  padding: 0px 4px;
  padding-bottom: 0px;
  padding-left: 0px;
  white-space: nowrap;
  background: ${({ $accent }) => (
    $accent || Color(topBarColor2).lighten(0.4).toString()
  )};
  font-size: 11px;
  border-radius: 3px;
  gap: 4px;
  width: max-content;
  margin-top: -3px;
  transform: translateY(5px);

  .MuiSvgIcon-root {
    transform: translateY(0);
  }
`;

export const Room = styled(Username)`
  padding: 0px 0px;
  font-weight: 600;
  padding-left: 0px;
  transform: translateY(-0.5px);
  border: none;
  background: none;
  color: ${roomAccent};
  letter-spacing: 0.25px;
  z-index: 1;
`;

export const RoomText = styled.div`
  transform: translateY(0px);
`;

/** Department name — same inline treatment as room, slightly deeper purple. */
export const External = styled(Room)`
  padding: 0;
  background: none;
  color: ${Color(lFColor).lighten(0.3).toString()};
`;

export const ExternalText = styled.div`
  transform: translateY(0px);
`;

export const TFoot = styled.div<{ isCashGroup: boolean }>`
  height: ${({ isCashGroup }) => isCashGroup ? mainFooterSize : pagesFooterSize};
  position: sticky;
  right: 0;
  bottom: ${({ isCashGroup }) => isCashGroup ? `-${mainFooterSize}` : `-${pagesFooterSize}`};
  width: 100%;
  background: white;
  border-radius: 3px;
  border-top-right-radius: 0px;
  border-top-left-radius: 0px;
  @media(max-width: ${logRes1}) {
    border-left: none;
  }
  @media(max-width: ${cashFooterRes}) {
    height: ${({ isCashGroup }) => isCashGroup && `calc(${mainFooterSize} + ${cashFooterSize})`};
    bottom: ${({ isCashGroup }) => isCashGroup && `calc(-1 * (${mainFooterSize} + ${cashFooterSize}))`};
  }
`;

export const TotalFooter = styled.div`
  height: ${totalFooterSize};
  padding: 0 0 0 30px;
  width: 100%;
  text-align: right;
  border-top: 1px solid ${Color(tableBorderColor).lighten(0.3).toString()};
  border-bottom: 1px solid ${Color(tableBorderColor).lighten(0.75).toString()};
  display: flex;
  align-items: center;
  box-sizing: border-box;
  @media(max-width: ${cashFooterRes}) {
    border-bottom: 1px solid ${Color(tableBorderColor).lighten(0.3).toString()};
  }
  @media(max-width: ${mobileRes2}) {
    padding: 0;
  }
`;

export const TotalCont = styled.div`
  display: inline-flex;
  align-items: center;
  height: 100%;
  margin-left: auto;
`;

export const TotalCont1 = styled.div`
  border-left: 1px solid ${Color('lightgrey').lighten(0.065).toString()};
  height: 100%;
  /* Grow with the figure; stay at least as wide as the Value column. */
  min-width: ${auditValueColumnWidth};
  width: max-content;
  box-sizing: border-box;
  padding: 0 30px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  flex-shrink: 0;
  @media(max-width: ${mobileRes2}) {
    min-width: ${valueTHWidth};
    padding: 0 15px;
  }
`;

export const Total = styled.div<{ isNegative: boolean; $neutral?: boolean }>`
  color: ${({ isNegative, $neutral }) => (
    $neutral ? topBarColor2 : isNegative ? redColor : cashColor
  )};
  font-weight: 700;
  font-size: 21px;
  letter-spacing: 0.35px;
  margin-left: auto;
  white-space: nowrap;
`;

export const TotalText = styled.div`
  color: ${Color(borderColor).darken(0.25).toString()};
  font-weight: 700;
  font-size: 13px;
  letter-spacing: 0.35px;
  padding-right: 12px;
`;

export const FormatLogs1 = styled.div`
  flex: 1;
  @media(max-width: ${cashFooterRes}) {
    display: none;
  }
`;

export const logSmallRes = '395px';
export const logSmallRes2 = '378px';
export const logMiniRes = '344px';
export const FormatLogs = styled.div<{ $hidden?: boolean }>`
  border-radius: 2px;
  width: max-content;
  height: max-content;
  margin-right: auto;
  display: flex;
  gap: ${({ $hidden }) => ($hidden ? '0' : '12px')};
  max-width: ${({ $hidden }) => ($hidden ? '0' : '720px')};
  opacity: ${({ $hidden }) => ($hidden ? 0 : 1)};
  overflow: hidden;
  pointer-events: ${({ $hidden }) => ($hidden ? 'none' : 'auto')};
  transform: translateY(${({ $hidden }) => ($hidden ? '6px' : '0')});
  transition:
    opacity 260ms ${leftSidePanelMotionEase},
    max-width ${LEFT_SIDE_PANEL_MOTION_MS}ms ${leftSidePanelMotionEase},
    gap ${LEFT_SIDE_PANEL_MOTION_MS}ms ${leftSidePanelMotionEase},
    transform 260ms ${leftSidePanelMotionEase};
  @media(max-width: ${logSmallRes}) {
    gap: ${({ $hidden }) => ($hidden ? '0' : '7px')};
  }
  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

const reportBannerIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(-6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

/** Temporary staff-report other-party visibility while Show logs jump is active. */
export const ReportViewAsBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  width: 100%;
  flex-shrink: 0;
  margin: 0 0 8px;
  padding: 8px 12px;
  border-radius: 8px;
  border: 1px solid ${Color(lFColor0).alpha(0.35).toString()};
  background: ${Color(lFColor0).alpha(0.08).toString()};
  font-size: 12.5px;
  line-height: 1.4;
  color: #2a3038;
  box-sizing: border-box;
  animation: ${reportBannerIn} 280ms ${leftSidePanelMotionEase};
  @media (prefers-reduced-motion: reduce) {
    animation: none;
  }
`;

export const ReportViewAsExit = styled.button`
  flex-shrink: 0;
  border: none;
  background: transparent;
  color: ${lFColor0};
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;
  padding: 2px 4px;
  &:hover {
    text-decoration: underline;
  }
`;

export const ReportViewAsActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
`;

export const FormatSet = styled.div`
  display: flex;
  align-items: center;
  font-weight: 400;
  color: #525252;
  font-size: 11px;
  gap: 5px;
  padding: 9px 9px;
  padding-right: 8px;
  border-radius: 8px;
  background: ${Color('lightgrey').lighten(0.15).toString()};
  cursor: pointer;
  @media(max-width: ${logSmallRes}) {
    font-size: 11px;
  }
  &:hover {
    background: ${Color('lightgrey').lighten(0.07).toString()};
  }
`;

/** Time range control — subtle theme tint when on, grey when off. */
export const TimeRangeSet = styled.button<{ $on?: boolean }>`
  display: inline-flex;
  align-items: center;
  font-weight: 500;
  color: ${({ $on }) => ($on ? topBarColor : '#525252')};
  font-size: 11px;
  gap: 5px;
  padding: 9px 9px;
  border-radius: 8px;
  border: none;
  background: ${({ $on }) => ($on
    ? Color(topBarColor).alpha(0.1).toString()
    : Color('lightgrey').lighten(0.15).toString())};
  cursor: pointer;
  font-family: inherit;
  @media(max-width: ${logSmallRes}) {
    font-size: 11px;
  }
  &:hover:not(:disabled) {
    background: ${({ $on }) => ($on
    ? Color(topBarColor).alpha(0.14).toString()
    : Color('lightgrey').lighten(0.07).toString())};
  }
  &:disabled {
    opacity: 0.55;
    cursor: default;
  }
`;

export const ShowCashIn = styled.div`
`;

export const Select = styled.input`
  height: 13px;
  width: 13px;
  margin: 0;
  margin-bottom: 0px;
  pointer-events: none;
  accent-color: ${topBarColor};
`;

export const ShowCashOut = styled(ShowCashIn)`
`;

export const All = styled(ShowCashIn)`
`;

export const CashFooter = styled.div`
  width: 100%;
  height: ${cashFooterSize};
  display: none;
  border-bottom: 1px solid ${Color(tableBorderColor).lighten(0.75).toString()};
  @media(max-width: ${cashFooterRes}) {
    display: block;
  }
`;

export const FormatLogs2 = styled.div<{ $hidden?: boolean }>`
  display: flex;
  align-items: center;
  padding-left: 30px;
  height: 100%;
  max-width: ${({ $hidden }) => ($hidden ? '0' : 'none')};
  opacity: ${({ $hidden }) => ($hidden ? 0 : 1)};
  overflow: hidden;
  pointer-events: ${({ $hidden }) => ($hidden ? 'none' : 'auto')};
  transition:
    opacity 260ms ${leftSidePanelMotionEase},
    max-width ${LEFT_SIDE_PANEL_MOTION_MS}ms ${leftSidePanelMotionEase};
  @media(max-width: ${mobileRes2}) {
    padding-left: 15px;
  }
  @media (prefers-reduced-motion: reduce) {
    transition: none;
  }
`;

export const PagesFooter = styled.div<{ isCashGroup: boolean }>`
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${pagesFooterSize};
  width: 100%;
  margin-left: 0px;
  border-top: ${({ isCashGroup }) => !isCashGroup && `1px solid ${Color(tableBorderColor)
    .lighten(0.2).toString()}`};
`;

export const Pages = styled.div`
  display: flex;
  align-items: center;
`;

export const FormatLogs3 = styled(FormatLogs2)`
  margin-right: auto;
`;

export const PaginationCont = styled.div`
  margin-left: auto;
  margin-right: 30px;
  @media(max-width: ${mobileRes2}) {
    margin-right: 10px;
  }
`;

export const InfoContainer = styled.div`
  flex: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  pointer-events: none;
`;

export const InfoCont = styled.div`
  margin-bottom: 0px;
  width: max-content;
  max-width: 400px;
  background: transparent;
  padding: 10px 40px;
  padding-bottom: 40px;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
`;

export const EmptyIconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100px;
  height: 100px;
  border-radius: 50%;
  background: ${Color(bgColor).darken(0.03).toString()};
  color: ${Color('#525252').lighten(0.5).toString()};
  margin-bottom: 8px;
`;

export const NoResults = styled.div`
  font-size: 22px;
  margin: 0;
  width: max-content;
  font-weight: 600;
  color: ${Color('#525252').darken(0.1).toString()};
`;

export const Info = styled.div`
  font-size: 15px;
  color: ${Color('#525252').lighten(0.2).toString()};
  width: 100%;
  text-align: center;
  margin-top: 0;
  line-height: 1.4;
  max-width: 320px;
`;
